import React, {useRef, useState} from 'react';
import {PresetListsDM, PresetSizes} from "../interfaces";
import Preset from "../../common/components/preset";
import Gallery from "../../../galleries/gallery/gallery";
import { PresetDM, PresetTagDM, ProfileDM } from '../../common/interfaces';
import {useWindowSize} from "../../../../domain/common";
import {OLP_DESKTOP_BREAKPOINT} from "../constants";
import {Popup} from "../../../../ui/popup/popup";

export interface PresetListProps {
    presetsIDs:number[];
    presetListData:PresetListsDM;
    imgCdnDomain:string;
    creatorsPath:string;
    loop?:boolean;
    isDarkBackground?:boolean;
    cancelImgLazyload?:boolean;
    presetSizes?:string | null;
}
const PresetList = (props:PresetListProps) => {


    const ListPresets = props.presetsIDs.map(presetId => (props.presetListData.presets as PresetDM[]).filter(preset => presetId === preset.presetID)[0]);
    const size = useWindowSize();
    const isDesktop = size.width !== undefined && size.width > OLP_DESKTOP_BREAKPOINT;

    const presetSizes: PresetSizes = JSON.parse(props.presetSizes || '{"d":5.5,"t":2.5,"m":1.2}') as PresetSizes;
    const DesktopItemsPerSlide = isDesktop ? presetSizes.d : 3;

    //if the list's length is the same as the number of items that ara visible --> disable loop (hide arrows)
    const isLoop = (isDesktop && ListPresets.length <= DesktopItemsPerSlide) ? false : props.loop;
    const listContainerRef = useRef<HTMLDivElement>(null);
    const [showLinkCopiedPopup, setShowLinkCopiedPopup] = useState(false);

    /*
        For preset-visit-chaim copy link and dargNdrop popups
        Adding zIndex for prioritize position from other preset containers ( with absolute position ).
    */
    const mouseOver = (evnt:any) => {
        evnt.currentTarget.parentNode.style.zIndex = 1;
    }

    const mouseOut = (evnt:any) => {
        evnt.currentTarget.parentNode.style.zIndex = 0;
    }


    return (
        <div className="w-full" ref={listContainerRef}>
            <Gallery
                allowVerticalScrolling={ true }
                isArrowsOverflow={true}

                //for StudioVerse --> positioning the arrows in the middle of the preset's and creator's image height
                //When this prop is defined, set the arrows height to slideItemWidth * arrowsHeightWidthRatio
                arrowsHeightWidthRatio={3/4}
                //for lg size set desktopItemsPerSlide to 3
                desktopItemsPerSlide={ DesktopItemsPerSlide }
                tableItemsPerSlide={ presetSizes.t }
                mobileItemsPerSlide={ presetSizes.m }
                codeName="cp"
                items={ ListPresets }
                loop={ isLoop }
                classes="w-full"
                gap={ 43}
                style={{ paddingRight:"0px", paddingLeft:"0px" }}
                duration={ 800 }
                arrowsColor={props.isDarkBackground ? "white" : undefined}
                renderItem={(preset: PresetDM, slideItemWidth: number,slideItemIndex: number) => {

                    const presetTags = (props.presetListData.presetTags as PresetTagDM[]).filter(tag => tag.presetID === preset.presetID);
                    const profileID = props.presetListData.presetProfilePairs.filter(pair => pair.presetID === preset.presetID)[0].profileID;
                    const profile = (props.presetListData.profiles as ProfileDM[]).filter(profile => profile.profileID === profileID)[0];
                    return (
                        <div key={preset.presetID} className="perspective backface-visibility"  onMouseLeave={mouseOut} onMouseEnter={mouseOver}>
                            <Preset preset={preset} profile={profile} isHandleLinked={true}  imgWidth={slideItemWidth} imgHeight={(slideItemWidth / 4)*3}
                                    presetTags={presetTags} imgCdnDomain={props.imgCdnDomain} isDarkBackground={props.isDarkBackground ? props.isDarkBackground : false}
                                    creatorsPath={props.creatorsPath} cancelImgLazyload={props.cancelImgLazyload ? props.cancelImgLazyload : undefined}
                                    presetListRef={listContainerRef} setShowLinkCopiedPopup={setShowLinkCopiedPopup} />
                        </div>
                    )
                }}
            />
            {showLinkCopiedPopup && <Popup classes="py-10" close={() => setShowLinkCopiedPopup(false)}>
                <div className="ok-box" role="alert">The link was copied to clipboard</div>
            </Popup>}
        </div>
    )
};

export default PresetList;